import type { RuleBackend, RuleDraftBackend } from 'types/rules';

import api from 'helpers/api';

export const fetchRules = () => api.get<RuleBackend[]>('/metrics/rules').then(({ data }) => data);
export const fetchRule = (id: number) => api.get<RuleBackend>(`/metrics/rules/${id}`).then(({ data }) => data);
export const createRule = (draft: RuleDraftBackend) => api.post<RuleBackend>('/metrics/rules', draft).then(({ data }) => data);
export const updateRule = (id: number, draft: RuleDraftBackend) => api.patch<RuleBackend>(`/metrics/rules/${id}`, draft).then(({ data }) => data);
export const deleteRule = (id: number) => api.delete(`/metrics/rules/${id}`) as Promise<void>;
